import { View, Text, Pressable, ActivityIndicator } from 'react-native';
import { strikerRunViewStyles as styles } from './StrikerRunView.styles';
import { STRIKER_RUN_ACCENT, STRIKER_RUN_TEST_IDS } from '../../../src/quiz/constants/strikerRun.constants';

interface StrikerRunOverlaysProps {
  status: 'loading' | 'ready' | 'error';
  onRetry: () => void;
}

/**
 * The host-side overlay layer: loading until the runtime posts `ready`, error + Retry on `load-error`.
 * Everything else (game over, restart, HUD) is drawn by the game canvas itself.
 */
export function StrikerRunOverlays({ status, onRetry }: StrikerRunOverlaysProps) {
  if (status === 'loading') {
    return (
      <View style={styles.overlay} testID={STRIKER_RUN_TEST_IDS.loading} pointerEvents="none">
        <ActivityIndicator color={STRIKER_RUN_ACCENT} />
      </View>
    );
  }
  if (status === 'error') {
    return (
      <View style={styles.overlay} testID={STRIKER_RUN_TEST_IDS.error}>
        <Text style={styles.message}>Could not load the game</Text>
        <Pressable
          testID={STRIKER_RUN_TEST_IDS.retry}
          onPress={onRetry}
          style={({ pressed }) => [styles.retryButton, pressed && styles.pressedDim]}
        >
          <Text style={styles.retryText}>Retry</Text>
        </Pressable>
      </View>
    );
  }
  return null;
}
